<div class="main-container">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between align-items-center">
                <span>ZingHR Employee</span>
            </div>
        </div>

        <div class="card-body p-0">
            <!-- <div class="filter-section">
                <form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
                    <div class="row g-3">
                        <div class="col-md-3">
                            <label for="EmpCode" class="form-label">Employee Code</label>
                            <input type="text" class="form-control" placeholder="Search by code" id="EmpCode"
                                name="EmpCode" [(ngModel)]="this.Filter.EmpCode" #EmpCode="ngModel" maxlength="100"
                                (change)="clear()">
                        </div>
                        <div class="col"></div>
                        <div class="col-md-auto align-self-end pb-2 gap-2">
                            <button type="button" (click)="reset()" class="btn btn-outline-primary">
                                <i class="bi bi-arrow-clockwise me-1"></i> Reset
                            </button>
                            <button class="btn btn-primary mx-2">
                                <i class="bi bi-funnel me-1"></i> Apply
                            </button>
                            <button type="button" class="btn btn-outline-primary"
                                [disabled]="this.EmployeeData.length == 0" (click)="ExportExcel()">
                                <i class="bi bi-download me-1"></i> Export
                            </button>
                        </div>
                    </div>
                </form>
            </div> -->

            <div class="table-container mt-2">
                <table class="customeDatatable table table-bordered">
                    <thead class="table-light">
                        <tr>
                            <th [ngClass]="{'colHide': !this.common.PageRight.IsEdit && !this.common.PageRight.IsView}">
                                Action</th>
                            <th>Details</th>
                            <th>Branch</th>
                            <th>Client</th>
                            <th>Site</th>
                            <th>Joining Date</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="EmployeeData.length == 0">
                            <td colspan="7" class="details-cell p-2">
                                <app-no-data></app-no-data>
                            </td>
                        </tr>

                        <ng-container *ngFor="let element of EmployeeData; let i = index">
                            <tr [class.expanded-row]="element.expanded">
                                <td [ngClass]="{'colHide': !this.common.PageRight.IsEdit && !this.common.PageRight.IsView}"
                                    class="p-1 align-content-center text-center">
                                    <div style="width:15rem">
                                        <button class="btn btn-primary btn-sm me-1" type="button"
                                            (click)="toggleRow(i)">
                                            <span class="expand-indicator">▼</span> Details
                                        </button>

                                        <button type="button" class="btn btn-primary btn-sm mx-1"
                                            (click)="CheckEditOrSync(i,'v')"><i class="bi bi-eye me-2"></i>View</button>

                                        <button type="button" class="btn btn-primary btn-sm mx-1"
                                            (click)="CheckEditOrSync(i,'i')"><i
                                                class="bi bi-pencil-square me-2"></i>Edit</button>
                                    </div>
                                </td>
                                <td>
                                    <div class="row" style="align-items: center;"
                                        style="align-items: center;width: 300px;">
                                        <div class="col-12">
                                            <span class="text-label">{{element['EmpName']}}</span><br />
                                            <span class="text-label-light">#{{element['EmpCode']}}
                                                <span>[ZingHR Code: {{element['ZingHrCode']}}]</span></span><br />
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    {{element['BranchName']}}
                                </td>
                                <td>
                                    {{element['ClientGroupName']}}
                                </td>
                                <td>
                                    {{element['SiteCode']}}-{{element['SiteName']}}
                                </td>
                                <td>
                                    {{element['JoiningDate']}}
                                </td>
                                <td>
                                    {{element['PresentStatus']}}
                                </td>
                            </tr>
                            <tr class="details-row" *ngIf="element.expanded">
                                <td colspan="7" class="details-cell p-2">
                                    <div class="details-grid">
                                        <div class="detail-item">
                                            <span class="detail-label">Employee Code</span>
                                            <span class="detail-value">
                                                {{element.EmpCode}}
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Zing Code</span>
                                            <span class="detail-value">
                                                {{element.ZingHrCode}}
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Employee Name</span>
                                            <span class="detail-value">
                                                {{element.EmpName}}
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Gender</span>
                                            <span class="detail-value">
                                                {{element.GenderName}}
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Email</span>
                                            <span class="detail-value">
                                                {{element.Email}}
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Contact No</span>
                                            <span class="detail-value">
                                                {{element.ContactNo1}}
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Birth Date</span>
                                            <span class="detail-value">
                                                {{element.BirthDate}}
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Joining Date</span>
                                            <span class="detail-value">
                                                {{element.JoiningDate}}
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Registration Date</span>
                                            <span class="detail-value">
                                                {{element.RegistrationDate}}
                                            </span>
                                        </div>
                                        <div class="detail-item">
                                            <span class="detail-label">Present Status</span>
                                            <span class="detail-value">
                                                {{element.PresentStatus}}
                                            </span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>